// @import_dependencies
import { store } from 'app_storage/redux-storage'
// @end

// @import services
// @end

// @import utilities
import { Http, HttpCustomStructure } from 'app_utils/http'
import { ScreenNotificationsUtil } from 'app_utils/screenNotification'
// @end

// @import types
import * as CertificateSettingsTypes from 'app_types/admin/certificateSettings/certificateSettings.types';
// @end

class CertificateMultipleService{

  private token: string
  private storeObject: any
  private Http: any
  private screenNotification: ScreenNotificationsUtil

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    public methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor () {
    this.Http = Http
    this.storeObject = store
    this.screenNotification = new ScreenNotificationsUtil()
  }

  refreshAuthToken = () => {
    let auth = this.storeObject.getState().auth
    this.token = (auth.user?.token) ? auth.user.token : ''
  }

  async getData(params: CertificateSettingsTypes.ICertificateMultipleDataParams)
    : Promise<CertificateSettingsTypes.ICertificateMultipleDataResponse | null> {
    this.refreshAuthToken()

    let responseData: CertificateSettingsTypes.ICertificateMultipleDataResponse

    const queryData: HttpCustomStructure = {
      method: 'POST',
      url: `/api/admin/certificate-multiple/certificate-data`,
      auth_token: this.token,
      params: {
        ...params,
      },
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData
    } else {
      this.screenNotification.fire(responseData)
    }

    return null
  }

  async getCertificatesByStudent(params: CertificateSettingsTypes.ICertificateMultipleByStudentParams)
    : Promise<CertificateSettingsTypes.ICertificateMultipleByStudentResponse | null> {
    this.refreshAuthToken()

    let responseData: CertificateSettingsTypes.ICertificateMultipleByStudentResponse

    const queryData: HttpCustomStructure = {
      method: 'POST',
      url: `/api/admin/certificate-multiple/certificate-data`,
      auth_token: this.token,
      params: {
        ...params,
      },
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData
    } else {
      this.screenNotification.fire(responseData)
    }

    return null
  }

  generateCertificates = async (params: CertificateSettingsTypes.ICertificateMultipleGenerateParams)
  : Promise<CertificateSettingsTypes.ICertificateMultipleGenerateResponse | null> => {
    this.refreshAuthToken()

    let responseData: CertificateSettingsTypes.ICertificateMultipleGenerateResponse

    const queryData: HttpCustomStructure = {
      method: 'POST',
      url: `/api/admin/certificate-multiple/generate-certificate`,
      auth_token: this.token,
      params: {
        ...params,
      },
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData
    } else {
      this.screenNotification.fire(responseData)
    }

    return null
  }
}

export default CertificateMultipleService;
